import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "backdrop", "content", "serviceSelect"]

  open(event) {
    if (event.cancelable) event.preventDefault()

    const serviceName = event.params.service
    
    if (this.hasServiceSelectTarget && serviceName) {
      const options = Array.from(this.serviceSelectTarget.options)
      const matchingOption = options.find(opt => opt.value === serviceName) || 
                             options.find(opt => opt.value.includes(serviceName))
      
      if (matchingOption) {
        this.serviceSelectTarget.value = matchingOption.value
      }
    }

    this.containerTarget.classList.remove("invisible")
    
    requestAnimationFrame(() => {
      this.backdropTarget.classList.remove("opacity-0")
      this.contentTarget.classList.remove("translate-x-full")
    })

    document.body.style.overflow = "hidden"
  }

  close(event) {
    if (event && event.cancelable) event.preventDefault()

    this.backdropTarget.classList.add("opacity-0")
    this.contentTarget.classList.add("translate-x-full")

    setTimeout(() => {
      this.containerTarget.classList.add("invisible")
      document.body.style.overflow = ""
    }, 300)
  }
}
